import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { debounceTime, filter, map, Subject, takeUntil } from 'rxjs';
import { /*App_FormFieldListUser, */App_FormFieldListe, App_TrueField } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-liste',
  templateUrl: './c-liste.component.html',
  styleUrls: ['./c-liste.component.scss'],
})
export class CListeComponent implements OnInit {
  @Input({ required: true }) field!: App_FormFieldListe/* | App_FormFieldListUser*/;
  @Input({ required: true }) cFormControl!: FormControl;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) disabledField!: boolean;
  @Input({ required: false }) noLabelNoErrorMessage: true | undefined;
  @Input({ required: false }) looksDisabled!: true | undefined;
  @Input() etatId?: number;
  /** Préfixe unique (ex. step.id + '-' + bloc.id) pour l’attribut id du trigger ion-modal ; évite les collisions si deux champs ont le même `field.name`. */
  @Input() selectTriggerScope?: string;
  @Output() triggerAlert = new EventEmitter<{
    blocName: string;
    fieldName: string;
    fieldFormControl: AbstractControl<any, any>;
    field: App_TrueField;
  }>();

  // TODO-pf? dynamiser pour les autres listes
  fieldNotFilled = {
    text: `Information obligatoire`,
    icon: [`fas`, `circle-check`],
  };

  destroyComponent$: Subject<boolean> = new Subject();

  /** Identifiant DOM pour ion-col et [trigger] du ion-modal (doit rester unique par instance à l’écran). */
  get selectTriggerId(): string {
    return this.selectTriggerScope
      ? `select-${this.selectTriggerScope}-${this.field.name}`
      : `select-${this.field.name}`;
  }

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.addAlertSubscriptions();
  }

  optionSelectionChanged(value: number | string | null) {
    this.cFormControl.setValue(value);
    this.cFormControl.markAsDirty();
    this.cFormControl.updateValueAndValidity();
    this.modalController.dismiss();
  }

  dismissModal() {
    this.modalController.dismiss()
  }

  addAlertSubscriptions() {
    const checkValidity = this.field.checkValidity;
    if (checkValidity !== undefined) {
      const validators = Array.isArray(checkValidity.validators)
      ? checkValidity.validators
      : [];
      const asyncValidators = Array.isArray(checkValidity.asyncValidators)
      ? checkValidity.asyncValidators
      : [];
      const allValidators = [
        ...validators,
        ...asyncValidators
      ];
      const validatorsWithTriggerAlert = allValidators.filter(validator => validator.triggerAlert);
      if (validatorsWithTriggerAlert.length > 0) {
        this.cFormControl.statusChanges.pipe(
          takeUntil(this.destroyComponent$),          
          debounceTime(200),
          filter(status => status === 'INVALID'),
          map(_ => {
            const errors = this.cFormControl.errors;
            if (errors !== null && (validatorsWithTriggerAlert.find(validator => errors[validator.type]) || (errors['err'] !== undefined && errors['err'][`type`] !== undefined && validatorsWithTriggerAlert.find(validator => errors['err'][`type`] === validator.type)))) {
              return errors;
            }
            return null;
          }),
          filter(_ => _ !== null),
        ).subscribe(errors => {
          this.triggerAlert.emit({
            blocName: this.blocName,
            fieldName: this.field.name,
            fieldFormControl: this.cFormControl,
            field: this.field,
          });
        })
      }
    }
  }


}
